import { createErrorHandler } from '../base';
import { aaLoadDataErrorConfig } from './error-config';
import i18n from '@/helper/i18n';

const t = i18n.chain;

export { aaLoadDataErrorConfig };
export const handleAALoadDataError = createErrorHandler(aaLoadDataErrorConfig);
